import React, { useState } from 'react';
import user from '../../../helpers/user';
import { InputOTP } from './InputOTP';
import InputPassword from './InputPassword';
import { InputPIN } from './InputPIN';
import { PurchaseSuccess } from './PurchaseSuccess';
import Portal from './Portal';
import useEscapeKey from '../../../hooks/useEscapeKey';
import { useRef } from 'react';
import { resetQitafProperty } from '../../../services/serviceWrapper/qitafServiceWrapper';

// export const TVODOverlayComponent = {
//     PIN: InputPIN,
//     OTP: InputOTP,
//     PASSWORD: InputPassword,
//     SUCCESS: PurchaseSuccess,
// };

export const TVODOverlayType = {
    PIN: 'PIN',
    OTP: 'OTP',
    PASSWORD: 'PASSWORD',
    SUCCESS: 'SUCCESS',
};

const TVODOverlay = ({ isOpen, onClose, ...props }) => {
    const overlayRef = useRef(null);

    const onOverlayClose = () => {
        setCurrentComponentType(type);
        resetQitafProperty('upadtedPrice');
        onClose();
    };

    useEscapeKey(onOverlayClose);
    const userInfo = user.getUserInfo();
    const operator = userInfo?.operator;
    const type = user.getTVODPurchaseOption(operator);
    const [currentComponentType, setCurrentComponentType] = useState(type);
    const Component = {
        PIN: InputPIN,
        OTP: InputOTP,
        PASSWORD: InputPassword,
        SUCCESS: PurchaseSuccess,
    }[currentComponentType];

    if (!type || !isOpen || !Component) return null;

    return (
        <Portal>
            <div className="popup-holder odd">
                <div className="popup-content" ref={overlayRef}>
                    <div className="option-group">
                        <div className="close-icon" onClick={onOverlayClose} style={{ zIndex: 2 }}>
                            <svg
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M26.4861 10.9288C26.8766 10.5383 26.8766 9.9051 26.4861 9.51457C26.0956 9.12405 25.4624 9.12405 25.0719 9.51457L18.0008 16.5857L10.9298 9.51467C10.5392 9.12415 9.90607 9.12415 9.51555 9.51467C9.12503 9.9052 9.12503 10.5384 9.51555 10.9289L16.5866 17.9999L9.51555 25.0709C9.12503 25.4614 9.12503 26.0946 9.51555 26.4851C9.90608 26.8757 10.5392 26.8757 10.9298 26.4851L18.0008 19.4141L25.0719 26.4852C25.4624 26.8758 26.0956 26.8758 26.4861 26.4852C26.8766 26.0947 26.8766 25.4615 26.4861 25.071L19.415 17.9999L26.4861 10.9288Z"
                                    fill="white"
                                    fillOpacity="0.5"
                                />
                            </svg>
                        </div>
                        <Component
                            {...props}
                            setCurrentComponentType={setCurrentComponentType}
                            onOverlayClose={onOverlayClose}
                        />
                    </div>
                </div>
            </div>
        </Portal>
    );
};

export default TVODOverlay;
